import axios from "axios";
import { useEffect, useState } from "react";
import { FaCcAmazonPay } from 'react-icons/fa6';
import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
// modified
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

import 'react-toastify/dist/ReactToastify.css';


export default function CustomerPayments() {
   const [payments, setPayments] = useState([]);
   const [currentPage, setCurrentPage] = useState(1);
   const paymentsPerPage = 7;

   const [searchTerm, setSearchTerm] = useState("");

   const navigate = useNavigate();

   useEffect(() => {
      fetchPayments();
   }, []);
   const exportToExcel = () => {
      if (payments.length === 0) {
         toast.warning("No data to export!");
         return;
      }

      const exportData = payments.map((p, index) => ({
         "S.No": index + 1,
         "Customer ID": p.cust_id || "-",
         "Customer Name": `${p.first_name || ""} ${p.last_name || ""}`,
         "Amount (₹)": p.net_total || "-",
         "Payment Method": p.payment_method || "-",
         "Frequency": p.paymentFrequency || "-",
         "Pickup Status": p.pickup_status || "-",
         "Payment Status": p.paymentStatus || "-",
         "Requested Date": p.created_at ? p.created_at.split("T")[0] : "-",
         "RC ID": p.rc_id || "-",
         "Center Name": p.center_name || "-",
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Payments");

      // Auto column width
      const columnWidths = Object.keys(exportData[0]).map((key) => ({
         wch: Math.max(
            key.length,
            ...exportData.map((row) => (row[key] ? row[key].toString().length : 0))
         ) + 2,
      }));
      worksheet["!cols"] = columnWidths;

      // Freeze header row
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      // Header styling: green background + white text + bold
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let C = range.s.c; C <= range.e.c; ++C) {
         const cellRef = XLSX.utils.encode_cell({ r: 0, c: C });
         if (!worksheet[cellRef]) continue;
         worksheet[cellRef].s = {
            font: { bold: true, color: { rgb: "FFFFFFFF" } }, // White text
            fill: { fgColor: { rgb: "FF2E7D32" } }, // Green background
            alignment: { horizontal: "center", vertical: "center" },
         };
      }

      // Align other rows
      for (let R = 1; R <= range.e.r; ++R) {
         for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
            if (worksheet[cellRef]) {
               worksheet[cellRef].s = {
                  alignment: { vertical: "center", horizontal: "center" },
               };
            }
         }
      }

      // Export
      const excelBuffer = XLSX.write(workbook, {
         bookType: "xlsx",
         type: "array",
         cellStyles: true,
      });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, `Customer_Payments_${new Date().toISOString().split("T")[0]}.xlsx`);
   };


   const fetchPayments = async () => {
      try {
         const rc_id = sessionStorage.getItem("rc_id");
         const center_name = sessionStorage.getItem("center_name");

         if (!rc_id || !center_name) {
            toast.error("❌ Missing Redemption Center details. Please log in again.");
            return;
         }

         const res = await axios.get("/auth/redem-customer-payments", {
            params: { rc_id, center_name },
         });

         setPayments(res.data);
      } catch (err) {
         console.error("Error fetching payments", err);
         toast.error("❌ Failed to load customer payments");
      }
   };



   // 🔍 Filter payments based on search
   const filteredPayments = payments.filter((payment) => {
      const search = searchTerm.toLowerCase();
      return (
         payment.cust_id?.toLowerCase().includes(search) ||
         `${payment.first_name} ${payment.last_name}`.toLowerCase().includes(search) ||
         payment.id?.toString().includes(search) ||
         payment.amount?.toString().includes(search) ||
         payment.created_at?.split("T")[0].includes(search)
      );
   });

   // Pagination after filtering
   const indexOfLastPayment = currentPage * paymentsPerPage;
   const indexOfFirstPayment = indexOfLastPayment - paymentsPerPage;
   const currentPayments = filteredPayments.slice(indexOfFirstPayment, indexOfLastPayment);
   const totalPages = Math.ceil(filteredPayments.length / paymentsPerPage);

   return (
      <div className="p-4">
         <div className="bg-white shadow-md rounded-2xl p-5 w-full">

            {/* 🔍 Search Bar */}
            <div className="flex flex-col sm:flex-row sm:justify-between items-center gap-4 mb-6 px-4">
               <h2 className="flex items-center gap-2 text-2xl font-bold text-green-800">
                  <FaCcAmazonPay className="text-3xl" /> Customer Payments
               </h2>
               <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto items-stretch sm:items-center">
                  <input
                     type="text"
                     placeholder="Search by ID, Name, Date, Amount..."
                     value={searchTerm}
                     onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                     }}
                     className="border px-4 py-2 rounded-lg w-full sm:w-80 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                  <button
                     onClick={exportToExcel}
                     disabled={payments.length === 0}
                     className={`px-4 py-2 rounded-lg transition ${payments.length === 0
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-green-600 hover:bg-green-700 text-white"
                        }`}
                  >
                     Export To Excel
                  </button>

               </div>
            </div>

            <div className="w-full overflow-x-auto">
               <table className="min-w-max w-full border border-gray-200">
                  <thead className="bg-lime-100 text-green-900 uppercase font-semibold">
                     <tr>
                        <th className="px-3 py-4">S.no</th>
                        <th className="px-4 py-4">Customer ID</th>
                        <th className="px-4 py-4">Name</th>
                        <th className="px-4 py-4">Amount</th>
                        <th className="px-4 py-4">Requested Date</th>
                        <th className="px-4 py-4">Payment Method</th>
                        <th className="px-4 py-4">Frequency</th>
                        <th className="px-4 py-4">Pickup Status</th>
                        <th className="px-4 py-4">Payment Status</th>
                        <th className="px-4 py-4">Actions</th>
                     </tr>
                  </thead>
                  <tbody>
                     {currentPayments.length > 0 ? (
                        currentPayments.map((payment, index) => (
                           <tr key={payment.id} className="bg-white border-b hover:bg-gray-50">
                              <td className="px-3 py-4 text-center">{indexOfFirstPayment + index + 1}</td>
                              <td className="px-4 py-4 text-center text-red-500">{payment.cust_id}</td>
                              <td className="px-4 py-4 text-center">{`${payment.first_name} ${payment.last_name}`}</td>
                              <td className="px-4 py-4 text-center">$ {payment.net_total}</td>
                              <td className="px-4 py-4 text-center">{payment.created_at?.split("T")[0]}</td>
                              <td className="px-4 py-4 text-center">{payment.payment_method || "N/A"}</td>
                              <td className="px-4 py-4 text-center">{payment.paymentFrequency || "N/A"}</td>
                              <td className="px-4 py-4 text-center">
                                 <span className={`text-xs font-medium px-2 py-1 rounded-lg ${payment.pickup_status === "completed"
                                    ? "bg-green-200 text-green-800"
                                    : "bg-red-200 text-red-800"
                                    }`}>
                                    {payment.pickup_status}
                                 </span>
                              </td>
                              <td className="px-4 py-4 text-center">
                                 <span className={`text-xs font-medium px-2 py-1 rounded-lg ${payment.paymentStatus === "completed"
                                    ? "bg-green-200 text-green-800"
                                    : payment.paymentStatus === "pending"
                                       ? "bg-yellow-200 text-yellow-800"
                                       : "bg-red-200 text-red-800"
                                    }`}>
                                    {payment.paymentStatus}
                                 </span>
                              </td>
                              <td className="px-4 py-4 flex justify-center gap-4">
                                 <button
                                    className="text-black-800 hover:text-green-700"
                                    onClick={() => navigate(`/redem-customer-payments/${payment.id}`)}

                                 >
                                    <GrView />
                                 </button>




                              </td>
                           </tr>
                        ))
                     ) : (
                        <tr>
                           <td colSpan="10" className="text-center py-8 text-gray-500">
                              No payment records found.
                           </td>
                        </tr>
                     )}
                  </tbody>
               </table>

               {/* Pagination Controls - updated to match DriverPayments */}
               {totalPages > 1 && (
                  <div className="flex justify-center mt-6 gap-2">
                     <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((prev) => prev - 1)}
                        className="px-3 py-1 border rounded-md disabled:opacity-50"
                     >
                        &lt;
                     </button>

                     {(() => {
                        const pages = [];
                        if (totalPages <= 6) {
                           for (let i = 1; i <= totalPages; i++) pages.push(i);
                        } else {
                           if (currentPage <= 3) {
                              pages.push(1, 2, 3, 4, "...", totalPages);
                           } else if (currentPage >= totalPages - 2) {
                              pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
                           } else {
                              pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
                           }
                        }
                        return pages.map((page, index) =>
                           page === "..." ? (
                              <span key={index} className="px-3 py-1">...</span>
                           ) : (
                              <button
                                 key={index}
                                 onClick={() => setCurrentPage(page)}
                                 className={`px-3 py-1 border rounded-md ${currentPage === page ? "bg-[#a3e635] text-white" : ""
                                    }`}
                              >
                                 {page}
                              </button>
                           )
                        );
                     })()}

                     <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((prev) => prev + 1)}
                        className="px-3 py-1 border rounded-md disabled:opacity-50"
                     >
                        &gt;
                     </button>
                  </div>
               )}
            </div>
         </div>

         {/* Modal */}

         <ToastContainer position="top-right" autoClose={3000} />
      </div>
   );
}
